import { Injectable } from '@angular/core';
import { IDynamicFormGroupDefinition } from '../../models/dynamic-form-group';

// This class stores a FormGroupDefinitions to be used in combination with the dynamic-forms.directive
// It grabs the FormGroup when putting together the Reactive Form with Base Inputs
@Injectable({
  providedIn: 'root',
})
export class FormInfoService {
  private formInfo: any;

  setFormInfo(formInfo: IDynamicFormGroupDefinition) {
    this.formInfo = formInfo;
  }

  getFormInfo(): IDynamicFormGroupDefinition {
    return this.formInfo;
  }
}
